(() => {
  angular.module('finance').component('organizationUtilizationInvoiceDetailTransactionViewComponent', {
    templateUrl: require('./organizationUtilizationTransactionView.component.html'),
    controller: OrganizationUtilizationInvoiceDetailTransactionViewComponent,
    controllerAs: 'vm',
    bindings: {
      currencyCode: '<',
      invoice: '<',
      invoiceFrom: '<',
      invoiceTo: '<',
      isAddressInvoiceFrom: '<',
      isAddressInvoiceTo: '<',
      message: '<',
      getDateString: '<'
    },
  });

  OrganizationUtilizationInvoiceDetailTransactionViewComponent.$inject = [];

  function OrganizationUtilizationInvoiceDetailTransactionViewComponent() {
    const vm = this;

    vm.loading = 0;

    init();

    function init() {}
  }
})();
